/*eslint-disable*/
import UserApi from '../../api/user/user.js';

export default {
    data() {
        return {
            amountOfActive: null,
            amountOfResolved: null
        };
    },
    mounted() {
        this.getAmounts();
    },
    watch: {
        amountOfActive (val) {
            if (!this.isSidebar) {
                this.$root.amountOfActive = val;
            }
        }
    },
    methods: {
        getAmounts() {
            this.isAmountsLoading = true;
            if (!this.$offline) {
                UserApi.amountsOfTickets()
                    .then(data => {
                        this.amountOfActive = data.data.amountOfActive;
                        this.amountOfResolved = data.data.amountOfResolved;
                        this.isAmountsLoading = false;
                    })
                    .catch(() => {
                        this.isAmountsLoading = false;
                    })
            }
        }
    }
}
